module.exports = __webpack_public_path__ + "static/media/openTip2.019cf80.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/mp3/openTip2.mp3
// module id = w2FX
// module chunks = 1